import styled from "styled-components";
import { InputText } from "discover.medical.react-component-library";

export const Input = styled(InputText)`
  width: 100%;
  max-width: 100%;

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    max-width: 22rem;

    input {
      padding-right: 10.5rem;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      border-left-color: ${({ theme }) => theme.colors.accent.dark};
    }
  }
`;

export const FormWrapper = styled.div`
  display: flex;
  flex: 1;
`;

export const InputLabel = styled.div`
  display: none;
  align-items: center;
  padding: 0 0.75rem 0 ${({ theme }) => theme.space.sm};
  flex: none;
  background: ${({ theme }) => theme.colors.accent.dark};
  border-radius: ${({ theme }) => theme.border.radius.sm} 0 0
    ${({ theme }) => theme.border.radius.sm};
  color: ${({ theme }) => theme.colors.white};
  font-size: ${({ theme }) => theme.font.size.xs};
  font-weight: ${({ theme }) => theme.font.weight.semibold};

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    display: flex;
  }
`;
